/**
 * Insights index.
 *
 * Display a form to pick which Advertiser and Campaign to run an Insights report on.
 *
 * Views: charts/medium_index
 */


if($('#chart_insights_continue').length > 0){
    var campaign_data;
    $('#campaign').select2({
        placeholder: "Select an Advertiser to continue."
    });
    $('#advertiser').select2({
        placeholder: "Please select an Advertiser"
    }).on('select2:select', function () {
        show_loader();
        var advertiser = $(this).val();
        var text_box = $('#chart_insights_continue');

        text_box.find('button').attr('disabled', 'disabled');
        text_box.find('.help-block').html('&nbsp;');

        $.ajax({
            url: '/charts/medium/campaigns/' + advertiser,
            type: 'GET',
            encode: true,
            success: function (data) {
                campaign_data = data;
                select = $('#campaign');
                select.html('');
                select.append('<option value=""></option>');
                $.each(data, function (index, value) {
                    select.append('<option value="' + value['campaign']['slug'] + '">' + value['campaign']['name'] + '</option>');
                });

                select.attr('disabled', null);

                if (select.data('select2')) {
                    select.data('select2').destroy();
                }
                select.select2({
                    placeholder: "Choose one to continue..."
                });

                select.unbind('select2:select').bind('select2:select', function () {

                    var slug = $(this).val();
                    var selected;

                    $.each(campaign_data, function (index, value) {
                        if (value['campaign']['slug'] == slug) {
                            selected = value;
                        }
                    });

                    if (selected['integrations'] == null) {
                        campaign_link = '/advertisers/' + $('#advertiser').val() + '/campaigns/' + $('#campaign').val();
                        text_box.find('.help-block').html('The selected campaign does not have any Integrations.<br />' +
                            'Please visit the <a href="' + campaign_link + '">Campaign Settings.</a>');
                        text_box.find('button').attr('disabled', 'disabled');
                    } else {
                        a = 'Available Integrations:<br/>';
                        $.each(selected['integrations'], function (index, value) {
                            if (value['service'] == 'google_analytics') {
                                a += '<i class="fa fa-google fa-fw"></i>';
                            }
                        });
                        text_box.find('.help-block').html(a);
                        text_box.find('button').attr('disabled', null).unbind('click').bind('click', function () {
                            window.location = '/charts/insights/' + $('#advertiser').val() + '/' + $('#campaign').val();
                        });
                    }
                });

                hide_loader();
            }
        });
    });
}